import { Controller } from "@hotwired/stimulus"

// Persists a <details> element's open/closed state in localStorage so it
// survives page navigation. The server-rendered `open` attribute is the
// default for first-time visitors; once the user toggles, their choice wins.
//
//   <details data-controller="details-memory"
//            data-details-memory-key-value="review-filters" open>
export default class extends Controller {
  static values = { key: String }

  connect() {
    const stored = localStorage.getItem(this.storageKey)
    if (stored !== null) this.element.open = stored === "open"
    this.save = this.save.bind(this)
    this.element.addEventListener("toggle", this.save)
  }

  disconnect() {
    this.element.removeEventListener("toggle", this.save)
  }

  save() {
    localStorage.setItem(this.storageKey, this.element.open ? "open" : "closed")
  }

  get storageKey() {
    return `details-memory:${this.keyValue}`
  }
}
